import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { Skeleton } from '~/shared/ui/components/Skeleton'
import * as showsBundlesModel from './model'

export function Title(): JSX.Element {
  return <AppTitle t='series_bundle' />
}

const skin = era.skin('routes/shows/bundles')

ShowBundlesPage.displayName = 'ShowBundlesPage'
export function ShowBundlesPage(): JSX.Element {
  const isContentLoading = useUnit(showsBundlesModel.$contentLoading)
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper>
        <Skeleton pageType='bundle' isLoading={isContentLoading}>
          <ui.RenderSkin name='bundle' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
